import { get } from '@jira/onboarding-browser-storage/src/controllers/index.tsx';

/**
 * Returns the team type a user selected via survey
 * during the onboarding flow.
 */
export const getTeamType = () => {
	const teamType = get('teamType');

	if (!teamType || typeof teamType.value !== 'string') {
		return null;
	}

	return teamType.value;
};

export const getOnboardingParams = () => ({
	teamType: getTeamType(),
});
